"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/GridLayout/index.ts
var GridLayout_exports = {};
__export(GridLayout_exports, {
  GridLayout: () => GridLayout,
  GridLayoutTile: () => GridLayoutTile
});
module.exports = __toCommonJS(GridLayout_exports);

// src/components/GridLayout/GridLayout.tsx
var import_react5 = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var import_styled = __toESM(require("@emotion/styled"));

// node_modules/react-use/esm/misc/util.js
function on(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.addEventListener) {
    obj.addEventListener.apply(obj, args);
  }
}
function off(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.removeEventListener) {
    obj.removeEventListener.apply(obj, args);
  }
}
var isBrowser = typeof window !== "undefined";

// node_modules/react-use/esm/useEffectOnce.js
var import_react = require("react");
var useEffectOnce = function(effect) {
  (0, import_react.useEffect)(effect, []);
};
var useEffectOnce_default = useEffectOnce;

// node_modules/react-use/esm/useRafState.js
var import_react3 = require("react");

// node_modules/react-use/esm/useUnmount.js
var import_react2 = require("react");
var useUnmount = function(fn) {
  var fnRef = (0, import_react2.useRef)(fn);
  fnRef.current = fn;
  useEffectOnce_default(function() {
    return function() {
      return fnRef.current();
    };
  });
};
var useUnmount_default = useUnmount;

// node_modules/react-use/esm/useRafState.js
var useRafState = function(initialState) {
  var frame = (0, import_react3.useRef)(0);
  var _a = (0, import_react3.useState)(initialState), state = _a[0], setState = _a[1];
  var setRafState = (0, import_react3.useCallback)(function(value) {
    cancelAnimationFrame(frame.current);
    frame.current = requestAnimationFrame(function() {
      setState(value);
    });
  }, []);
  useUnmount_default(function() {
    cancelAnimationFrame(frame.current);
  });
  return [state, setRafState];
};
var useRafState_default = useRafState;

// node_modules/react-use/esm/useWindowSize.js
var import_react4 = require("react");
var useWindowSize = function(initialWidth, initialHeight) {
  if (initialWidth === void 0) {
    initialWidth = Infinity;
  }
  if (initialHeight === void 0) {
    initialHeight = Infinity;
  }
  var _a = useRafState_default({
    width: isBrowser ? window.innerWidth : initialWidth,
    height: isBrowser ? window.innerHeight : initialHeight
  }), state = _a[0], setState = _a[1];
  (0, import_react4.useEffect)(function() {
    if (isBrowser) {
      var handler_1 = function() {
        setState({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };
      on(window, "resize", handler_1);
      return function() {
        off(window, "resize", handler_1);
      };
    }
  }, []);
  return state;
};
var useWindowSize_default = useWindowSize;

// src/components/GridLayout/GridLayout.tsx
var Container = import_styled.default.div`
  @media (max-width: 400px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;
function GridLayout({
  containerRef,
  className,
  children
}) {
  const { width } = useWindowSize_default();
  const gridRef = containerRef != null ? containerRef : (0, import_react5.useRef)(null);
  function resizeGridItem(item, rowHeight, rowGap) {
    if (!item.firstChild) {
      item.style.display = "none";
      return;
    }
    const rowSpan = Math.ceil(
      (item.firstChild.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap)
    );
    item.style.gridRowEnd = `span ${rowSpan}`;
  }
  function resizeAllGridItems() {
    var _a;
    const tiles = (_a = gridRef.current) == null ? void 0 : _a.children;
    if (!tiles)
      return;
    const gridStyles = window.getComputedStyle(gridRef.current);
    const rowHeight = parseInt(gridStyles.gridAutoRows);
    const rowGap = parseInt(gridStyles.rowGap);
    for (const tile of Array.from(tiles)) {
      resizeGridItem(tile, rowHeight, rowGap);
    }
  }
  const tileResizeObserver = (0, import_react5.useRef)(
    new ResizeObserver((entries) => {
      entries.forEach(() => {
        resizeAllGridItems();
      });
    })
  );
  (0, import_react5.useLayoutEffect)(() => {
    resizeAllGridItems();
  }, [width, children]);
  (0, import_react5.useEffect)(() => {
    var _a;
    const tiles = (_a = gridRef.current) == null ? void 0 : _a.children;
    if (!tiles || !tileResizeObserver)
      return;
    for (const tile of Array.from(tiles)) {
      if (tile && tile.children[0]) {
        tileResizeObserver.current.observe(tile.children[0]);
      }
    }
    return () => {
      if (tileResizeObserver) {
        for (const tile of Array.from(tiles)) {
          if (tile && tile.children[0]) {
            tileResizeObserver.current.unobserve(tile.children[0]);
          }
        }
        tileResizeObserver.current.disconnect();
      }
    };
  }, [children, tileResizeObserver]);
  return /* @__PURE__ */ import_react5.default.createElement(
    Container,
    {
      id: "bonjoro-grid-layout",
      ref: gridRef,
      className: (0, import_classnames.default)("grid-layout", className, [
        "v2-grid v2-gap-2.5 v2-grid-cols-[repeat(auto-fill,_minmax(350px,1fr))]",
        "v2-auto-rows-[10px] v2-transition v2-transition-all v2-ease-in"
      ])
    },
    children
  );
}

// src/components/GridLayout/GridLayoutTile.tsx
var import_react6 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));
function GridLayoutTile({
  className,
  contentClassName,
  children
}) {
  return /* @__PURE__ */ import_react6.default.createElement("div", { className: (0, import_classnames2.default)("grid-layout-tile v2-h-full", className) }, /* @__PURE__ */ import_react6.default.createElement("div", { className: (0, import_classnames2.default)("v2-w-auto v2-h-auto v2-relative", contentClassName) }, children));
}
